<template>
  <div>
    <div
      class="con-list f-clearfix"
      v-for="(item, index) in clommAndCourse"
      :key="index"
      v-if="item.courses2.length > 0"
    >
      <div class="body-tool course-tool">
        <h2>{{ item.name }}</h2>
        <span @click="toCourseList(item)">更多课程 &gt;</span>
      </div>
      <ul class="index-course f-clearfix">
        <li
          v-for="(child, index) in item.courses2"
          :key="index"
          :title="child.name"
        >
          <div
            id="item-course-tags-b"
            :class="
              showTag(child.id).tagId == '1169810873999269889'
                ? 'tagA'
                : showTag(child.id).tagId == '1242344957122658306'
                ? 'tagB'
                : 'tagC'
            "
            v-if="showTag(child.id) != null"
          ></div>
          <div
            v-if="showTag(child.id) != null"
            id="item-course-tags"
            :class="
              showTag(child.id).tagId == '1169810873999269889'
                ? 'tagA'
                : showTag(child.id).tagId == '1242344957122658306'
                ? 'tagB'
                : 'tagC'
            "
          >
            <span :title="showTag(child.id).title">{{
              showTag(child.id).title
            }}</span>
          </div>
          <a :href="child.ctUrl" target="_blank">
            <div class="item-img">
              <img v-img.lazy="child.ctImgUrl" :alt="child.name" />
            </div>
            <h3>{{ child.name }}</h3>
            <div class="item-teacher">
              <span class="item-school">{{ child.teacherName }}</span>
            </div>
            <div>
              <span class="item-school">{{ child.schoolName }}</span>
              <span class="item-edu"> {{ child.enrollCount || 0 }}人选课 </span>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      clommAndCourse: [],
      tagMap: {},
      name: 1,
      statusList: [],
    };
  },
  mounted() {
    this.name = this.$route.query.siteId || 1;
    this.getList();
  },
  methods: {
    toCourseList(item) {
      if (item.tagId && this.$route.query.siteId == 6) {
        window.open(
          `/ruralPromote?tagId=${item.tagId}&tagName=${item.name}&siteId=6`
        );
      } else {
        window.open(
          `/course?pathFalg=new&categoryId=&tagCourseId=&collegeId=&tagProjectId=&status=&key=`
        );
      }
    },
    getList() {
      this.tableMap = [];
      this.tableMapFlag = [];
      let par = {
        siteId: this.name,
        type: 1,
      };
      this.$http
        .get("/api/manager/customize/getInfo", { params: par })
        .then((res) => {
          this.clommAndCourse = JSON.parse(res.data.content) || [];
          for (var i of this.clommAndCourse) {
            this.$set(i, "courses2", []);
          }
          let ids = [];
          this.clommAndCourse.forEach((el) => {
            el.courses.forEach((c) => {
              ids.push(c.id);
            });
          });
          this.getTags(ids.join(","));
          this.getStatus(ids.join(","));
          this.$emit("getRecommend", this.clommAndCourse.length > 0);
        })
        .catch((msg) => {});
    },
    //此接口用于通过课程id，判断课程是否禁用，禁用课程首页不显示（manager/customize/getInfo接口无法实时判断已禁用课程）
    getStatus(val) {
      let par = {
        ids: val,
      };
      this.$http
        .get("/api/web/course/enableIds", { params: par })
        .then((res) => {
          this.statusList = res.data;
          for (var i of this.statusList) {
            for (var j of this.clommAndCourse) {
              for (var k of j.courses) {
                if (i == k.id) {
                  j.courses2.push(k);
                }
              }
            }
          }
        })
        .catch((msg) => {});
    },
    getTags(val) {
      let par = {
        ids: val,
        type: "PROJECT",
      };
      this.$http
        .post("/api/web/course/getTagByIds", par)
        .then((res) => {
          this.tagMap = res.data;
        })
        .catch((msg) => {});
    },
    showTag(id) {
      return this.tagMap[id];
    },
  },
};
</script>
<style lang="scss">
.index-course {
  overflow: hidden;
  margin-top: 20px;
  margin-bottom: 30px;
  :nth-child(4n) {
    margin-right: 0px;
  }
  li {
    float: left;
    width: 280px;
    margin-right: 26px;
    margin-bottom: 26px;
    position: relative;
    a:hover {
      color: #2f3440;
    }
    .item-img {
      width: 280px;
      height: 160px;
      border-radius: 4px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        transition: all 0.2s ease-in-out;
      }
    }
    h3 {
      font-size: 16px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 40px;
    }
    .item-teacher{
      height:20px;
    }
    div {
      // height: 40px;
      // line-height: 40px;
      span {
        color: #777;
        font-size: 12px;
      }
      .item-school {
        float: left;
        width: 180px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .item-edu {
        float: right;
        text-align: right;
      }
    }
    &:hover {
      cursor: pointer;
      img {
        opacity: 0.8;
        transform: scale(1.1);
        transition: all 0.4s ease-in-out;
      }
    }
  }
}
</style>
